import { Link } from "react-router-dom";
import { Section, Eyebrow } from "@/components/Section";

export default function NotFound() {
  return (
    <Section testId="not-found" className="!pt-32 !pb-32">
      <div className="max-w-2xl">
        <Eyebrow>404</Eyebrow>
        <h1 className="font-serif-display text-5xl sm:text-7xl mt-5 text-[#2E3630] leading-[1.02]">
          This page wandered off.
        </h1>
        <p className="font-body mt-6 text-lg text-[#5F6B62]">
          Let's get you somewhere useful.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" data-testid="notfound-home" className="btn-pill btn-primary">Back home</Link>
          <Link to="/contact" data-testid="notfound-contact" className="btn-pill btn-outline">Contact</Link>
        </div>
      </div>
    </Section>
  );
}
